import { render, staticRenderFns } from "./AppHead.vue?vue&type=template&id=cd823248&scoped=true&"
import script from "./AppHead.vue?vue&type=script&lang=ts&"
export * from "./AppHead.vue?vue&type=script&lang=ts&"
import style0 from "./AppHead.vue?vue&type=style&index=0&id=cd823248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd823248",
  null
  
)

component.options.__file = "AppHead.vue"
export default component.exports